<div class="p-card p-corner-all p-list-card">
  <div class="p-card-body">
    <div class="flex gap-md card-header">
      <div *ngIf="product?.photo?.url" class="product-thumbnail">
        <img [attr.src]="product.photo.url" />
      </div>
      <div class="flex-column gap-sm">
        <div class="p-card-title">{{ product?.name }}</div>
        <div *ngIf="product?.brand" class="p-card-subtitle">
          {{ product?.brand }}
        </div>
        <div [innerHTML]="product?.shortDescription"></div>
      </div>
    </div>
    <div class="p-card-content">
      <vnm-product-bundle [products]="product?.bundledProducts"></vnm-product-bundle>
      <!-- <vnm-category-badges [categories]="product?.categories"></vnm-category-badges> -->
    </div>
  </div>
  <div class="p-card-footer">
    <div class="p-card-title price-container">
      <ng-container *ngIf="discount > 0; else noDiscount">
        <div class="flex justify-content-between gap-xs">
          <span>{{ priceWithDiscount | currency }}</span>
          <span class="discount">-${{ discount }}</span>
        </div>
        <div class="striked">{{ price | currency }}</div>
      </ng-container>
      <ng-template #noDiscount>
        <div class="flex justify-content-between gap-xs">
          <span>{{ priceWithDiscount | currency }}</span>
        </div>
      </ng-template>
    </div>
    <vnm-add-to-cart [product]="product" class="add-to-cart"></vnm-add-to-cart>
  </div>
</div>
